module.exports = __webpack_public_path__ + "media/icons/map-pin@3x-blue-7a0cac93.svg";